import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RichTextStyles } from "@cinch-labs/design-system";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import Image from "next/legacy/image";
import styles from "./jargon-content.module.css";
export const JargonContent = ({ question , answer , image  })=>/*#__PURE__*/ _jsxs("article", {
        className: styles.article,
        "data-testid": "jargon-article",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.content,
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: styles.question,
                        children: question
                    }),
                    /*#__PURE__*/ _jsxs(RichTextStyles, {
                        children: [
                            renderWithResolver(answer),
                            " "
                        ]
                    })
                ]
            }),
            image && image.filename && /*#__PURE__*/ _jsx("div", {
                className: styles.imageWrapper,
                children: /*#__PURE__*/ _jsx(Image, {
                    src: image.filename,
                    className: styles.jargonImage,
                    layout: "responsive",
                    width: 592,
                    height: 310,
                    objectFit: "contain"
                })
            })
        ]
    });
